import { render } from "./ReferenceDetail.vue?vue&type=template&id=2d5d52f6&scoped=true&ts=true"
import script from "./ReferenceDetail.vue?vue&type=script&lang=ts"
export * from "./ReferenceDetail.vue?vue&type=script&lang=ts"

import "./ReferenceDetail.vue?vue&type=style&index=0&id=2d5d52f6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5d52f6"]])

export default __exports__